import React from "react";

import Chip from "@mui/joy/Chip";
import {CircularProgress} from "@mui/joy";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import BaseApi from "../../utils/BaseApi";
import {b64toBlob, downloadBlob} from "../../utils/misc";

// icons
import AttachFileIcon from '@mui/icons-material/AttachFile';


class CommentAttachment extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            attachment: null,
            download: false,
        }
    }

    async componentDidMount() {
        await this.retrieveAttachment();
    }

    async retrieveAttachment() {
        const url = `attachment/${this.props.id}`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        this.setState(
            {
                attachment: response.data
            }
        );
    }

    async download(){
        this.setState({
            download: true
        })
        const api = new BaseApi();
        const url = `attachment/${this.props.id}/download/`;
        let response = await api.get(url, {});
        downloadBlob(
            b64toBlob(response.data.content),
            response.data.filename,
            ''
        )
        this.setState({
            download: false
        })
    }

    render(){
        if (!this.state.attachment){
            return (<CircularProgress/>)
        }
        return (
            <>
                <Chip
                    size={'sm'}
                    startDecorator={<AttachFileIcon/>}
                    onClick={this.props.link?this.download.bind(this):null}
                >
                    {this.state.attachment.uploadname}
                </Chip>
                {
                    this.state.download?
                        <CircularProgress
                          size="sm"
                        />:
                        null
                }
            </>
        )
    }
}

export default CommentAttachment